import { TodoView } from '@/views/Dashboard/TodoView';

export function TodoPage() {
  return <TodoView />;
}
